<div class="field">
  <div class="control">
    <div class="box schedule-display">
      <div class="columns is-vcentered">
        <div class="column">
          <p class="schedule-summary">{{ getScheduleSummary() }}</p>
        </div>
        <div class="column is-narrow">
          <button class="button is-info is-small" (click)="openModal()" [disabled]="disabled">
            <span class="icon">
              <i class="fas fa-edit"></i>
            </span>
            <span>Edit</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" [class.is-active]="isModalActive">
  <div class="modal-background" (click)="closeModal()"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit {{scheduleName}}</p>
      <button class="delete" aria-label="close" (click)="closeModal()"></button>
    </header>

    <section class="modal-card-body">
      <div class="message is-info mb-4">
        <div class="message-body">
          <strong>Current Schedule:</strong><br>
          {{ getScheduleSummary() }}
        </div>
      </div>

      <form [formGroup]="scheduleForm">
        <div class="field is-horizontal">
          <div class="field-label">
            <label class="label">Frequency</label>
          </div>
          <div class="field-body">
            @if (scheduleForm.get('timePeriod')?.value == timePeriods.Once) {
              <div class="field">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="timePeriod">
                      <option [value]="timePeriods.Once">Once</option>
                      <option [value]="timePeriods.Daily">Daily</option>
                      <option [value]="timePeriods.Weekly">Weekly</option>
                      <option [value]="timePeriods.Monthly">Monthly</option>
                      <option [value]="timePeriods.Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
              </div>
            }
            @if (scheduleForm.get('timePeriod')?.value != timePeriods.Once) {
              <div class="field has-addons">
                <div class="control">
                  <button class="button is-static">Every</button>
                </div>
                <div class="control">
                  <input
                    class="input"
                    type="number"
                    formControlName="interval"
                    min="1"
                    max="999">
                  </div>
                  <div class="control">
                    <div class="select">
                      <select formControlName="timePeriod">
                        <option [value]="timePeriods.Daily">Days</option>
                        <option [value]="timePeriods.Weekly">Weeks</option>
                        <option [value]="timePeriods.Monthly">Months</option>
                        <option [value]="timePeriods.Yearly">Years</option>
                        <option [value]="timePeriods.Once">Once</option>
                      </select>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>

          @if (scheduleForm.get('timePeriod')?.value == timePeriods.Weekly) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Day of Week</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <app-dropdown-grid
                    [options]="weekdayOptions"
                    [value]="scheduleForm.get('weekday')?.value"
                    (valueChange)="selectWeekday($event)"
                    anyOptionLabel="Any Day"
                    [columns]="3">
                  </app-dropdown-grid>
                </div>
              </div>
            </div>
          }

          @if (scheduleForm.get('timePeriod')?.value == timePeriods.Yearly) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Month</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <app-dropdown-grid
                    [options]="monthOptions"
                    [value]="scheduleForm.get('monthOfYear')?.value"
                    (valueChange)="selectMonth($event)"
                    anyOptionLabel="Any Month"
                    [columns]="3">
                  </app-dropdown-grid>
                </div>
              </div>
            </div>
          }

          @if (scheduleForm.get('timePeriod')?.value >= timePeriods.Monthly && scheduleForm.get('timePeriod')?.value != timePeriods.Once) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Day of Month</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <app-dropdown-grid
                    [options]="getDayOptions()"
                    [value]="scheduleForm.get('dayOfMonth')?.value"
                    (valueChange)="selectDayOfMonth($event)"
                    anyOptionLabel="Any Day"
                    [columns]="7">
                  </app-dropdown-grid>
                </div>
              </div>
            </div>
          }

          @if (allowTimeOfDay && scheduleForm.get('timePeriod')?.value != timePeriods.Once) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Time of Day</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input class="input" type="time" formControlName="timeOfDay">
                  </div>
                </div>
              </div>
            </div>
          }

          @if (enableDateShifting && scheduleForm.get('timePeriod')?.value != timePeriods.Once) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Avoid Weekends</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <app-toggleswitch
                      formControlName="disallowWeekends"
                      SwitchStyle="rounded">
                    </app-toggleswitch>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (enableDateShifting && scheduleForm.get('timePeriod')?.value != timePeriods.Once) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Avoid Public Holidays</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <app-toggleswitch
                      formControlName="disallowPublicHolidays"
                      SwitchStyle="rounded">
                    </app-toggleswitch>
                  </div>
                </div>
              </div>
            </div>
          }

          @if (enableDateShifting && (scheduleForm.get('disallowWeekends')?.value || scheduleForm.get('disallowPublicHolidays')?.value)) {
            <div class="field is-horizontal">
              <div class="field-label">
                <label class="label">Date Shift Direction</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select formControlName="dateShiftDirection">
                        <option [value]="dateShiftDirections.PushForward">Move Forward</option>
                        <option [value]="dateShiftDirections.PullBack">Move Backward</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </form>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-success" (click)="save()" [disabled]="!scheduleForm.valid">Save</button>
        <button class="button" (click)="closeModal()">Cancel</button>
      </footer>
    </div>
  </div>